import { useLocale } from "../../hooks/locale";

export const HomeRedirect = () => {
	const { webflowHomepageUrl } = useLocale();

	return <Redirect to={webflowHomepageUrl} />;
};

export const LegacyToWebflowRedirect = ({ to }) => {
	const { webflowHomepageUrl } = useLocale();

	return <Redirect to={`${webflowHomepageUrl}/${to}`} />;
};

export const Redirect = ({ to }) => {
	window.location.href = to;

	return null;
};
